export class DashboardLinksModel {
    usage;
    overage;
    consumption;
    consumptionWarmTier;
    consumptionTrial;
}
//# sourceMappingURL=periscope.js.map